import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} payload - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onFontSuccess = (payload = null, type = types.SUCCESS_FONT) => {
  return {
    type,
    payload
  };
};

export const isFontLoading = (payload = null, type = types.LOADING_FONT) => {
  return {
    type,
    payload
  };
};
